import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../../hook";
import { useMemo } from "react";
import { approverType } from "../../code-process/codeRequestType";
import { ITToolRequestService } from "../../../../../services/it-tools-request/itToolRequest.service";

export const useDetailsDFS = () => {
  const { id } = useParams<{ id: string }>();
  const { checkCurrentUser } = useUser();

  const { data, isLoading } = useQuery({
    queryKey: ["demand-for-supplies-requests", id],
    queryFn: () => ITToolRequestService.getITToolRequest(id),
    enabled: !!id,
  });

  const isPin = useMemo(() => {
    if (!data) return false;
    const pins: any[] = data.fields.ePins ? JSON.parse(data.fields.ePins) : [];
    return pins.findIndex((pin: string) => checkCurrentUser(pin)) >= 0;
  }, [checkCurrentUser, data]);

  const approvalType: number = useMemo(() => {
    if (!data) return 0;
    const { eApprovedBy, eApprovedByITLead, eAssignee, eApprovedStatus, eApprovedByITLeadStatus, eAssigneeStatus } =
      data?.fields;
    const approverEmail = eApprovedBy ? eApprovedBy.split("|")[0] : "";
    const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split("|")[0] : "";
    const assigneeEmail = eAssignee ? eAssignee.split("|")[0] : "";

    if (checkCurrentUser(approverEmail) && !eApprovedStatus) return approverType.approver;
    if (checkCurrentUser(approvedByITLeadEmail) && !eApprovedByITLeadStatus) return approverType.itlead;
    if (checkCurrentUser(assigneeEmail) && !eAssigneeStatus) return approverType.assignee;
    return 0;
  }, [data, checkCurrentUser]);

  const approvalStep: number = useMemo(() => {
    if (!data) return approverType.approver;
    const { eApprovedStatus, eApprovedByITLeadStatus, eAssigneeStatus } = data?.fields;
    if (!eApprovedStatus) return approverType.approver;
    if (!eApprovedByITLeadStatus) return approverType.itlead;
    if (!eAssigneeStatus) return approverType.assignee;
    return approverType.approver;
  }, [data]);

  return { data, isLoading, isPin, approvalStep, approvalType };
};
